var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.013 7c.268-.002.526-.103.717-.282l4.965-4.707A.956.956 0 0012 1.317c0-.26-.108-.51-.302-.695a1.064 1.064 0 00-.731-.289c-.275 0-.538.103-.733.286L6 4.634 1.766.619a1.075 1.075 0 00-1-.252 1.01 1.01 0 00-.731.696c-.095.339.008.7.27.948L5.27 6.718c.198.185.466.286.743.282z",
    fill: "#333"
  })));
}
export default SvgCatalogSelectArrow;